import { EncounterTimerDisplay } from "components/shared/EncounterTimer/EncounterTimer";
import React, { useEffect } from "react";

interface AttributeProps {
    memberId: string;
}

export default function Surveys({memberId}: AttributeProps) {
  useEffect(() => {
    window.scroll({
      top: 172,
      left: 0,
      behavior: "smooth"
    });
  }, []);

  return (
    <div>
      <EncounterTimerDisplay/>
      {/*<iframe src={'https://respiratory.prd.life365inc.com/#'} style={{width: '100%', height: '600px'}}/>*/}
      <iframe
        src={"https://phs.avixena.com"}
        style={{ width: "90%", height: "45vh", marginLeft: "8%" }}
      />
    </div>
  );
}
